const status = [
    "CREATED","INPROGRESS","FINISHED"
];
export default status